module.exports = __webpack_public_path__ + "img/pattern-divider-mobile.afbe147e.svg";